import _URL from "@babel/runtime-corejs3/core-js/url";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { GenericModal } from "@Shared/components/modals";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "SyncEmailsModal",
  components: {
    GenericModal
  },
  props: {
    syncedEmails: {
      type: Object,
      required: true
    },
    resyncEmail: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    getNylasConnectUrl() {
      const url = new _URL(this.syncedEmails.syncUrl);
      url.searchParams.set("redirect_uri", `${window.location.origin}/nylas-callback`);
      return url.toString();
    }
  }
});